import React, { useState, useEffect } from 'react';
import { fetchRequestAnalysis, fetchUserDetails } from "../utils/Api";

const AnalysisOptionSelect = ({ value, onChange }) => {
  const [analysisTypes, setAnalysisTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const analysisTypeMap = {
    "Insight,Foot": "Foot - Insight",
    "Insight,Foot,loc": "Foot - Insight - Localisation",
    "Insight,Foot,loc,indiv": "Foot - Insight - Individualisation",
    "Insight,Rugby,PS": "Rugby - Insight - Plan Serré",
    "Insight,Rugby,PS,indiv": "Rugby - Insight - Plan Serré - Individualisation",
    "Insight,Rugby,PL": "Rugby - Insight - Plan Large",
    "Insight,Rugby,PL,loc": "Rugby - Insight - Plan Large - Localisation",
    "Lineout": "Rugby - Lineout",
    "TxT": "Rugby - TxT",
    "Tracking,Rugby": "Rugby - Tracking",
    "Tracking,Rugby,parquet": "Rugby - Tracking - parquet",
    "Tracking,Foot": "Foot - Tracking",
  };

  const defaultAnalysisTypes = [
    "Insight,Foot",
    "Insight,Foot,loc",
    "Insight,Foot,loc,indiv",
    "Insight,Rugby,PS,indiv",
    "Insight,Rugby,PS",
    "Insight,Rugby,PL",
    "Insight,Rugby,PL,loc",
    "Lineout",
    "TxT",
    "Tracking,Rugby",
    "Tracking,Rugby,parquet",
    "Tracking,Foot",
  ];

  // Charger les données au montage du composant
  useEffect(() => {
    const loadData = async () => {
      const userId = localStorage.getItem("userId");

      const userDetails = await fetchUserDetails(userId);
      const analysisTypes = userDetails.analysis_types || [];
      console.log("analysisTypes:", analysisTypes);

      if (analysisTypes.length > 0) {
        setAnalysisTypes(userDetails.analysis_types);
      } else {
        console.warn("No analysis types found, using default.");
        setAnalysisTypes(defaultAnalysisTypes);
      }
      setIsLoading(false);
    };
    loadData();
  }, []);

  if (isLoading) {
    return <select className="optionbar" disabled><option>Chargement...</option></select>;
  }

  const sortedAnalysisTypes = [...analysisTypes].sort((a, b) => {
    const aLabel = analysisTypeMap[a] || a;
    const bLabel = analysisTypeMap[b] || b;
    return aLabel.localeCompare(bLabel);
  });

  return (
    <select
      className="optionbar"
      id="analysisOption"
      name="analysisOption"
      value={value}
      onChange={onChange}
    >
      <option value="" disabled>Select Analysis</option>
      {sortedAnalysisTypes.map((type, index) => (
        <option key={index} value={type}>
          {analysisTypeMap[type] || type}
        </option>
      ))}
    </select>
  );
};

export default AnalysisOptionSelect;

